"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var _GenericFormElement = _interopRequireDefault(require("../GenericFormElement"));

var _withMapping = _interopRequireDefault(require("../../../Context/withMapping"));

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var Checkbox = function Checkbox(props) {
  var title = props.title,
      required = props.required,
      description = props.description,
      fieldName = props.fieldName,
      validation = props.validation,
      touched = props.touched,
      error = props.error,
      value = props.value,
      displayRequiredIndicator = props.displayRequiredIndicator,
      _onChange = props.onChange,
      className = props.className,
      wrapperClassName = props.wrapperClassName,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  return /*#__PURE__*/_react.default.createElement(_GenericFormElement.default, {
    className: (0, _classnames.default)('Checkbox', wrapperClassName),
    required: required,
    description: description,
    fieldName: fieldName,
    touched: touched,
    error: error,
    displayRequiredIndicator: displayRequiredIndicator
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    required: required,
    name: fieldName,
    value: value,
    validate: validation
  }, function (_ref) {
    var field = _ref.field,
        form = _ref.form;
    var id = "".concat(props.fieldName, "--").concat(props.value);
    var classes = (0, _classnames.default)('WebformCheckboxes__checkbox__input', {
      'icon-before': true,
      'icon-checkmark': true,
      'icon-variant-1': field.value
    });
    return /*#__PURE__*/_react.default.createElement("label", {
      className: classes,
      htmlFor: id
    }, /*#__PURE__*/_react.default.createElement("input", _extends({}, field, {
      name: fieldName,
      type: "checkbox",
      id: id,
      checked: field.value,
      onChange: function onChange(e) {
        field.onChange(e);

        _onChange(!field.value);
      },
      disabled: disabled,
      className: className
    })), title);
  }));
};

Checkbox.defaultProps = {
  onChange: function onChange() {}
};

var _default = (0, _withMapping.default)(Checkbox);

exports.default = _default;